import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const depositHistorySchema = z.object({
  /** 入金トランザクションの一意なID */
  id: z.string(),
  /** 入金金額（文字列形式の数値） */
  amount: decimalSchema,
  /** 入金された暗号資産のシンボル（例: BNB, IOTA） */
  coin: z.string(),
  /** 使用されたブロックチェーンネットワーク */
  network: z.string(),
  /** 入金のステータス（例: 1 は成功） */
  status: z.number(),
  /** 入金に使用されたウォレットアドレス */
  address: z.string(),
  /** アドレスタグ（必要な場合のみ、空文字の場合もあり） */
  addressTag: z.string(),
  /** ブロックチェーン上のトランザクションID */
  txId: z.string(),
  /** 入金リクエストのタイムスタンプ（ミリ秒） */
  insertTime: z.number().int(),
  /** 入金完了のタイムスタンプ（ミリ秒）※2025年3月6日以降の入金にのみ有効 */
  completeTime: z.number().int().optional(),
  /** 転送タイプ（0 = 入金） */
  transferType: z.number(),
  /** 承認状況（例: "1/1"） */
  confirmTimes: z.string(),
  /** アンロックに必要な承認数 */
  unlockConfirm: z.number(),
  /** ウォレット種別（例: 0 = 通常ウォレット） */
  walletType: z.number(),
})

export const responseSchema = z.array(depositHistorySchema)
